<template>
    <section class="data">
        <div class="container">
            <div class="paragraph" data-aos="fade-right">
                <h2>Data</h2>
                <p>
                    コク（味全体の強さ）の数値が高い料理には、同じくコクの強い飲み物がマッチします。スパイシーなカレーとジントニックはともに3つの項目で高い数値を出していてその相性は抜群です。
                </p>
            </div>
            <div class="wrapper">
                <div class="container">    
                    <div class="content jin">
                        <div class="caption jin" data-aos="fade-right" data-aos-delay="400">
                            <Cap01 class="cap1"/>
                            <Graph01 class="graph1"/>
                        </div>
                        <div class="img-box" data-aos="fade-right">
                            <img src="@/assets/img/jintonic.png" alt="">
                        </div>
                    </div>
                    <div class="content wine">
                        <div class="caption wine" data-aos="fade-left">
                            <Graph02 class="graph2" />
                            <Cap02 class="cap2 hideSp"/>
                            <Cap02Sp class="cap2 hidePc"/>
                        </div>
                    </div>
                    <p class="from hidePc">味博士率いるAISSY調べ</p>
                </div>
                <img src="@/assets/img/curry.png" alt="" class="curry" data-aos="curry-left" data-aos-offset="300">
            </div>
        </div>
    </section>
</template>

<script>
import Cap01 from '@/assets/img/caption_01.svg?inline'
import Cap02 from '@/assets/img/caption_02.svg?inline'
import Cap02Sp from '@/assets/img/caption_02_sp.svg?inline'
import Graph01 from '@/assets/img/pentagram_01.svg?inline'
import Graph02 from '@/assets/img/pentagram_02.svg?inline'

export default {
    components:{
        Cap01,Cap02,Graph01,Graph02,Cap02Sp
    }
}
</script>

<style lang="scss" scoped>
.data{
    background-image: url('~@/assets/img/wood_bg.jpg');
    background-size: cover;
    background-position: center;
    position: relative;
    .curry{
        position: absolute;
        right: 0;
        bottom: 0;
        height: 100%;
        width: auto;
        //transform: translateX(54%);
        @media #{$minMax}{
            //transform: translateX(30%);
        }
        @media #{$maxL}{
            //transform: translateX(60%);
        }
        @media #{$maxM}{
            height: 50%;
            bottom: -40px;
        }
    }
    .paragraph{
        color: #fff;
        @media #{$maxM}{
            margin-bottom: 8vh;
        }
    }
    .wrapper{
        position: relative;
        width: 100vw;
        margin-top: 120px;
        height: 100%;
        @extend %flex;
        @media #{$maxM}{
            margin-top: 0;
        }
        .container{
            padding-top: 0;
            padding-bottom: 0;
            align-items: flex-start;
        }
        p.from{
            color: #fff;
            margin-top: 24px;
            font-size: 10px;
        }
        .content{
            position: relative;
            @extend %flex;
            width: calc(70% - 40px);
            max-width: 760px;
            height: 50%;
            @media #{$maxM}{
                width: 60%;
            }
            &.jin{
                flex-flow: row nowrap;
                //align-items: stretch;
                margin-bottom: 120px;
                @media #{$maxM}{
                    flex-flow: row-reverse nowrap;
                    width: 100%;
                    margin-bottom: 15vh;
                    justify-content: flex-start;
                    align-items: flex-start;
                }
                .img-box{
                    position: relative;
                    width: calc(50% - 20px);
                    @media #{$maxM}{
                        position: absolute;
                        left: -15%;
                        width: 50%;
                        //max-height: 540px;
                    }
                    img{
                        width: 100%;
                        height: auto;
                        max-height: 100%;
                    }
                }
            }
            
            .caption{
                color: #00A9D3;
                font-size: 1.688em;
                @extend %flex;
                width: 100%;
                justify-content: space-between;
                align-items: center;
                &.wine{
                    flex-flow: row-reverse nowrap;
                    @media #{$maxM}{
                        flex-flow: column-reverse;
                        align-items: center;
                    }
                }
                &.jin{
                    width: calc(60% - 20px);
                    @media #{$maxM}{
                        width: 64%;
                    }
                }
                    .cap1{
                        fill: $Blue;
                        margin-bottom: 72px;
                        @media #{$maxM}{
                            margin-bottom: 24px;
                        }
                    }
                    .cap2{
                        fill: #fff;
                        padding: 0 10% 0 5%;
                        width: 50%;
                        @media #{$maxM}{
                            width: 75%;
                            margin-bottom: 24px;
                            padding: 0;
                        }
                    }
                    .graph1{
                        .graph01-1,.graph01-3{fill:none;}
                        .graph01-2{fill:#00a9d3;}
                        .graph01-3{stroke:#fff;stroke-miterlimit:10;stroke-width:1.44px;}
                        .graph01-4{fill:#fff;}
                        @media #{$IE}{
                            width: 100%;
                            min-height: 320px;
                        }
                    }
                    .graph2{
                        width: 50%;
                        margin-right: 10%;
                        @media #{$maxM}{
                            width: 100%;
                            margin-right: 0;
                        }
                        .graph02-1{fill:#999;}
                        .graph02-2,.graph02-3{fill:none;}
                        .graph02-3{stroke:#fff;stroke-miterlimit:10;stroke-width:1.1px;}
                        .graph02-4{fill:#fff;}
                    }
            }
        }
    }
}

</style>